module.exports = __webpack_public_path__ + "img/451022.c237994f.png";